import React, { useEffect, useState } from "react";
import Header from "../../components/Header/Header";
import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import { SIDE_NAV_LIST } from "../../constant/AppConstant";
import { useLogoutUserMutation } from "../../redux/services/authApi";
import RegularModal from "../../components/Modals/RegularModal";
import { MdCancel } from "react-icons/md";
import { reset } from "../../redux/slices/authSlice";
import { resetCustomer } from "../../redux/slices/customerSlice";
import { resetNav } from "../../redux/slices/navSlice";
import { useDispatch } from "react-redux";
import Footer from "../../components/Footer/Footer";

type Props = {};

const SideNavBar = (props: Props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [visible, setVisible] = useState(false);
  const currentUser: any = JSON.parse(localStorage.getItem("user") || "{}");
  const token: string = currentUser?.jwtToken;
  const [logoutUser, logoutResponse] = useLogoutUserMutation();
  const currentPath = location.pathname;
  const HIDE_LEFTBAR = [
    "/profile/dashboard",
    "/profile/find-vehicle",
    "/profile/Booking-detail",
    "/profile/select-parking-slot",
    "/profile/payment",
    "/profile/payment/*",
    "/profile/payment-checkout",
    "/profile/payment-successful",
    "/profile/auth/login",
    "/profile/auth/signUp",
    "/profile/auth/finish",
    "/profile/auth/create-account",
    "/profile/auth/creation-success",
  ];

  const shouldHideSidebar = (path: string) => {
    return HIDE_LEFTBAR.some(route => {
      if (route.endsWith("/*")) {
        const base = route.replace("/*", "");
        return path.startsWith(base);
      }
      return path === route;
    });
  };


  useEffect(() => {
    if (token != null) {
      setIsLoggedIn(true);
    }
  }, [token]);

  useEffect(() => {
    if (logoutResponse.isSuccess) {
      navigate("/");
    }
  }, [logoutResponse.isSuccess]);
  const [menuLinks, setMenuLinks] = useState(SIDE_NAV_LIST);

  return (
    <div>
      <div className="h-[90px]">
        <Header position={"fixed"} isLoggedIn={isLoggedIn} />
      </div>
      <div className="container mx-auto">
        <div className="flex flex-row">
          {currentPath && !shouldHideSidebar(currentPath) && (
            <aside className="w-full sm:w-1/3 md:w-1/4 lg:w-[20%] mt-2 rounded-xl p-4 h-auto md:h-[400px] m-4 bg-[#F9F4EF] hidden md:block">
              <div className="w-full">
                <ul className="flex flex-col overflow-hidden relative">
                  {menuLinks.map((menuItem, index) => (
                    menuItem.title === "Logout" ? (
                      <button
                        key={index}
                        onClick={() => setVisible(true)}
                        className="flex items-center text-sm p-2 mt-1 overflow-hidden text-gray-700 text-ellipsis whitespace-nowrap rounded-full hover:bg-[#ED1C24] hover:text-white group"
                      >
                        <span className="mr-2 w-6 h-6">
                          {/* Show red icon by default and white icon on hover */}
                          <span className="block group-hover:hidden">{menuItem.icon1}</span>
                          <span className="hidden group-hover:block">{menuItem.icon2}</span>
                        </span>
                        <h6 className="hidden md:block">{menuItem.title}</h6>
                      </button>
                    ) : (
                      <NavLink
                        key={index}
                        to={menuItem.link}
                        className={({ isActive }) =>
                          `${isActive ? "bg-[#ED1C24] text-white" : ""
                          } flex items-center text-sm p-2 overflow-hidden text-gray-700 text-ellipsis whitespace-nowrap rounded-full`
                        }
                      >
                        {({ isActive }) => (
                          <>
                            <span className="mr-2 w-6 h-6">
                              {isActive ? menuItem.icon2 : menuItem.icon1}
                            </span>
                            <h6 className="hidden md:block">{menuItem.title}</h6>
                          </>
                        )}
                      </NavLink>
                    )
                  ))}
                </ul>
              </div>
            </aside>
          )}
          <main
            role="main"
            className={`w-full ${!shouldHideSidebar(currentPath) ? "sm:w-2/3 md:w-[75%] lg:w-[75%]" : ""}`}
          >
            <Outlet />
          </main>
        </div>
      </div>
      {visible && (
        <RegularModal
          modalDialogStyle="lg:w-[430px] bg-[#F9F4EF] w-[390px] lg:h-[295px] md:h-[300px] h-[270px] rounded-[8px]"
          visible={visible}
          setVisible={setVisible}
        >
          <p
            onClick={() => {
              setVisible(false);
            }}
            className="flex justify-end m-1"
          >
            <MdCancel size={24} color={"#ED1C24"} />
          </p>
          <p className="text-center text-gray-500 mt-4 text-[#434343] text-[24px] font-semibold lg:text-[28px]">
            Are You Sure to Logout ?
          </p>
          <div className="flex flex-col md:flex-row md:items-center md:justify-center mx-[1.75rem] mt-10 gap-4">
            <button
              onClick={() => {
                setVisible(false);
              }}
              className="w-full md:w-1/2 bg-[#ED1C24] text-white font-semibold p-2 rounded-full shadow-md"
            >
              No
            </button>

            <button
              onClick={() => {
                console.log("logout ");
                localStorage.clear();
                localStorage.setItem("isLoggedIn", "false");
                logoutUser({});
                dispatch(resetCustomer());
                dispatch(reset());
                dispatch(resetNav());
                setVisible(false);
              }}
              className="w-full md:w-1/2 bg-[#ED1C24] text-white p-2 font-semibold rounded-full mt-4 md:mt-0 shadow-md"
            >
              Yes
            </button>
          </div>
        </RegularModal>
      )}
      <Footer />
    </div>
  );
};
export default SideNavBar;
